// theme.js - Core functionality for ICONWALL on Shopify

document.addEventListener('DOMContentLoaded', () => {
    const cartIcon = document.getElementById('cart-icon');
    const closeCartBtn = document.getElementById('close-cart');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartItemsContainer = document.querySelector('.cart-drawer .overflow-y-auto');
    const cartCountBadge = document.getElementById('cart-count');
    const cartSubtotal = document.getElementById('cart-subtotal');

    const money = (cents) => (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    const escapeHTML = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

    function openCart() {
        if (cartDrawer && cartOverlay) {
            cartDrawer.classList.add('open');
            cartOverlay.classList.add('open');
            document.body.style.overflow = 'hidden';
        }
    }

    function closeCart() {
        if (cartDrawer && cartOverlay) {
            cartDrawer.classList.remove('open');
            cartOverlay.classList.remove('open');
            document.body.style.overflow = '';
        }
    }

    if (cartIcon) cartIcon.addEventListener('click', (event) => { event.preventDefault(); openCart(); });
    if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    function updateCartUI(cart) {
        if (!cartItemsContainer) return;
        cartItemsContainer.innerHTML = '';

        if (!cart || cart.item_count === 0) {
            cartItemsContainer.innerHTML = '<div class="text-center text-gray-500 mt-10">Il tuo carrello è vuoto.</div>';
        } else {
            cart.items.forEach((item) => {
                const itemEl = document.createElement('div');
                itemEl.className = 'flex gap-4 items-center bg-dark p-3 rounded border border-dark-border mb-4';
                itemEl.innerHTML = `
                    ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" class="w-20 h-20 object-cover rounded">` : '<div class="w-20 h-20 bg-dark-card rounded flex items-center justify-center text-xs text-gold">IW</div>'}
                    <div class="flex-1">
                        <h4 class="text-sm font-bold">${escapeHTML(item.product_title)}</h4>
                        <p class="text-xs text-gray-400">${escapeHTML(item.variant_title || '')}</p>
                        <div class="flex justify-between items-center mt-2">
                            <div class="flex items-center border border-dark-border rounded">
                                <button class="px-2 py-1 hover:bg-dark-border dec-qty" data-line="${escapeHTML(item.key)}" data-qty="${item.quantity}" aria-label="Diminuisci quantità">-</button>
                                <span class="px-2 text-sm">${item.quantity}</span>
                                <button class="px-2 py-1 hover:bg-dark-border inc-qty" data-line="${escapeHTML(item.key)}" data-qty="${item.quantity}" aria-label="Aumenta quantità">+</button>
                            </div>
                            <span class="font-bold text-gold">${money(item.line_price)}</span>
                        </div>
                    </div>
                `;
                cartItemsContainer.appendChild(itemEl);
            });
        }

        if (cartCountBadge) {
            cartCountBadge.innerText = cart ? cart.item_count : 0;
            cartCountBadge.classList.toggle('hidden', !cart || cart.item_count === 0);
        }
        if (cartSubtotal) cartSubtotal.innerText = money(cart ? cart.total_price : 0);

        cartItemsContainer.querySelectorAll('.dec-qty').forEach((btn) => {
            btn.addEventListener('click', function () {
                changeCartItem(this.getAttribute('data-line'), Math.max(parseInt(this.getAttribute('data-qty'), 10) - 1, 0));
            });
        });
        cartItemsContainer.querySelectorAll('.inc-qty').forEach((btn) => {
            btn.addEventListener('click', function () {
                changeCartItem(this.getAttribute('data-line'), parseInt(this.getAttribute('data-qty'), 10) + 1);
            });
        });
    }

    function fetchCart() {
        fetch('/cart.js')
            .then((res) => res.json())
            .then(updateCartUI)
            .catch((err) => console.error('Cart fetch error:', err));
    }

    function changeCartItem(line, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line, quantity })
        })
            .then((res) => res.json())
            .then(updateCartUI)
            .catch((err) => console.error('Cart change error:', err));
    }

    fetchCart();

    document.querySelectorAll('[data-product-form] input.variant-selector').forEach((input) => {
        input.addEventListener('change', function () {
            const form = this.closest('[data-product-form]');
            if (!form) return;
            const selected = form.querySelector('input.variant-selector:checked') || form.querySelector('input.variant-selector[type="hidden"]');
            const button = form.querySelector('.add-to-cart-btn');
            const priceEl = form.querySelector('#product-price');
            const comparePriceEl = form.querySelector('#product-compare-price');
            if (selected && button) button.setAttribute('data-variant-id', selected.value);
            if (selected && priceEl && selected.dataset.price) priceEl.innerText = selected.dataset.price;
            if (selected && comparePriceEl) {
                const hasDiscount = selected.dataset.hasDiscount === 'true';
                comparePriceEl.innerText = hasDiscount ? selected.dataset.comparePrice : '';
                comparePriceEl.classList.toggle('hidden', !hasDiscount);
            }
        });
    });

    document.addEventListener('click', function (event) {
        const btn = event.target.closest('.add-to-cart-btn');
        if (!btn) return;
        event.preventDefault();
        if (btn.disabled || btn.dataset.loading === 'true') return;

        const scope = btn.closest('[data-product-form]') || btn.closest('.product-card') || document;
        const selectedVariant = scope.querySelector('input.variant-selector:checked') || scope.querySelector('input.variant-selector[type="hidden"]');
        const variantId = selectedVariant ? selectedVariant.value : btn.getAttribute('data-variant-id');

        if (!variantId) {
            alert('Variante prodotto non trovata. Controlla le varianti A4/A3 su Shopify.');
            return;
        }

        btn.dataset.loading = 'true';
        btn.classList.add('opacity-50', 'cursor-not-allowed');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
            .then(async (res) => {
                if (!res.ok) throw await res.json();
                return res.json();
            })
            .then(() => fetchCart())
            .then(openCart)
            .catch((err) => {
                console.error('Add to cart error:', err);
                alert("Errore nell'aggiunta al carrello. Controlla disponibilità e varianti.");
            })
            .finally(() => {
                btn.dataset.loading = 'false';
                btn.classList.remove('opacity-50', 'cursor-not-allowed');
            });
    });

    const checkoutBtn = document.querySelector('.cart-drawer button.bg-gold-gradient');
    if (checkoutBtn) checkoutBtn.addEventListener('click', () => { window.location.href = '/checkout'; });

    const mainProductImage = document.getElementById('main-product-image');
    const thumbnails = document.querySelectorAll('.gallery-thumbnail');
    if (mainProductImage && thumbnails.length > 0) {
        thumbnails.forEach((thumb) => {
            thumb.addEventListener('click', function () {
                thumbnails.forEach((t) => t.classList.remove('ring-2', 'ring-gold'));
                this.classList.add('ring-2', 'ring-gold');
                mainProductImage.src = this.dataset.full || this.src;
            });
        });
    }

    const header = document.getElementById('main-header');
    if (header) {
        window.addEventListener('scroll', () => {
            header.classList.toggle('shadow-lg', window.scrollY > 50);
            header.classList.toggle('backdrop-blur-md', window.scrollY > 50);
        });
    }

    const mobileToggle = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileClose = document.getElementById('mobile-menu-close');
    if (mobileToggle && mobileMenu) mobileToggle.addEventListener('click', () => mobileMenu.classList.add('open'));
    if (mobileClose && mobileMenu) mobileClose.addEventListener('click', () => mobileMenu.classList.remove('open'));

    document.querySelectorAll('[data-search-wrapper]').forEach((searchWrapper) => {
        const searchInput = searchWrapper.querySelector('[data-search-input]');
        const searchResults = searchWrapper.querySelector('[data-search-results]');
        let searchTimeout = null;

        if (!searchInput || !searchResults) return;

        searchInput.addEventListener('input', function () {
            const query = this.value.trim();
            clearTimeout(searchTimeout);
            searchResults.innerHTML = '';

            if (query.length < 2) {
                searchResults.classList.add('hidden');
                return;
            }

            searchTimeout = setTimeout(() => {
                fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
                    .then((res) => res.json())
                    .then((data) => {
                        const products = data.resources && data.resources.results ? data.resources.results.products : [];
                        searchResults.innerHTML = '';
                        if (!products.length) {
                            searchResults.innerHTML = '<div class="p-4 text-gray-500 text-sm text-center">Nessun risultato trovato</div>';
                        } else {
                            products.forEach((product) => {
                                const item = document.createElement('a');
                                item.href = product.url;
                                item.className = 'flex items-center gap-3 p-3 hover:bg-dark-border transition-colors border-b border-dark-border last:border-0';
                                item.innerHTML = `
                                    ${product.image ? `<img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" class="w-12 h-12 object-cover rounded">` : '<div class="w-12 h-12 bg-dark rounded flex items-center justify-center text-xs text-gold">IW</div>'}
                                    <div class="flex-1">
                                        <h4 class="text-white text-sm font-bold">${escapeHTML(product.title)}</h4>
                                        <span class="text-gold text-xs">Vedi prodotto</span>
                                    </div>
                                `;
                                searchResults.appendChild(item);
                            });
                        }
                        searchResults.classList.remove('hidden');
                    })
                    .catch((err) => console.error('Search error:', err));
            }, 250);
        });

        document.addEventListener('click', function (event) {
            if (!searchWrapper.contains(event.target)) searchResults.classList.add('hidden');
        });
    });

    const priceFilter = document.getElementById('price-filter');
    const priceDisplay = document.getElementById('price-display');
    const productCards = document.querySelectorAll('.product-card[data-price]');
    if (priceFilter && priceDisplay) {
        priceFilter.addEventListener('input', function () {
            const maxPrice = parseInt(this.value, 10);
            priceDisplay.innerText = '€' + maxPrice;
            productCards.forEach((card) => {
                const cardPrice = parseFloat(card.getAttribute('data-price')) || 0;
                card.classList.toggle('hidden', cardPrice > maxPrice);
            });
        });
    }
});
